import clsx from 'clsx';
import styles from './DallasSkeleton.module.scss';

type SkeletonVariant =
  | 'text'
  | 'block'
  | 'semi-rounded'
  | 'rounded'
  | 'circular';

interface Props {
  className?: string;
  variant?: SkeletonVariant;
  width?: string | number;
  height?: string | number;
}

export default function DallasSkeleton({
  className,
  variant = 'block',
  width,
  height,
}: Props) {
  return (
    <span
      className={clsx(className, styles.root, styles[`variant_${variant}`])}
      style={{ width, height }}
    />
  );
}
